var uAjax = "/index.cfm/transaction/ajax";
// ECOMMA-4167: `uAjax` is a GLOBAL - global.js assigns it without `var` in a dozen places
// (addToWishlist, removeFromwishlist, subscribe, ...). callAjax() falls back to it whenever a
// call omits its url, so one wishlist click in the cart re-pointed every later cart call at
// /customer/ajax/addtowishlist, which answered "Missing product id". Cart calls now pass this
// module-local copy explicitly and cannot be re-pointed by anything outside this file.
var uAjaxBasket = "/index.cfm/transaction/ajax";

// Function to check cera validation state and enable/disable button accordingly
function checkCeraValidationState() {
	if ($('#ceraForm').length > 0) {
		// Count only filled fields that need validation
		var filledFieldsCount = 0;
		$('.edtCeraNumber').each(function() {
			if ($(this).val() !== '') {
				filledFieldsCount++;
			}
		});
		
		var validatedFieldsCount = $('.ceraValidIcon').length;
		
		// Enable if all filled fields are validated
		if (filledFieldsCount > 0 && validatedFieldsCount === filledFieldsCount) {
			enableTransactionSubmit();
		}
		// Disable if:
		// 1. No fields are filled yet (user hasn't validated anything)
		// 2. Some fields are filled but not all are validated
		else if (validatedFieldsCount === 0 || (filledFieldsCount > 0 && validatedFieldsCount < filledFieldsCount)) {
			disableTransactionSubmit();
		}
	}
}

$(function()
{
	// Hide webcode field on load
	$(el('edtWebCode')).closest('.control-group').hide();

	// Check cera validation state on page load
	checkCeraValidationState();

	// show popup for finalize error
  	if(bStockError === true)
 	{
		showAlert('error', sStockErrorMessage, false);
  	}

	if(sTransactionIndexErrorMessage !== "")
 	{
		showAlert('error', sTransactionIndexErrorMessage, false);
  	}

  	var oBasket = $(el('mainContainer'));
	// change quantity listeners
	oBasket.on('click', '.qtyMin', function()
	{
		changeQty($(this).next(), 'min');
		return false;
	});
	oBasket.on('click', '.qtyPlus', function()
	{
		changeQty($(this).prev(), 'plus');
		return false;
	});
	oBasket.on('change', '.edtQty', function()
	{
		var oEdtQty = $(this);

		// corrected on the spot so the number the customer sees is the number that gets sent
		if(oEdtQty.val() != 0) checkMultiplier(oEdtQty);

		queueLineQty(oEdtQty);
	});
	oBasket.on('click', '.btnRefresh', function()
	{
		var oEdtQty = $(this).closest('tr').find('.edtQty');

		checkMultiplier(oEdtQty);

		// an explicit "apply now" button: send it straight away, and drop any pending debounce for the line
		queueLineQty(oEdtQty, true);
	});

	// remove transaction line listener
	oBasket.on('click', '.btnRemove', function()
	{
		askRemoveLine($(this).attr("line-id"));
	});

	oBasket.on('click', '#removeLine', function()
	{
		removeLine($(this).attr("line-id"));
	});

	// cancel full transaction
	oBasket.on('click', '#cancelFullOrderBtnId', function()
	{
		$('#cancelOrderModal').modal('toggle');
	});

	// giftvoucher form listener
	oBasket.on('click', '#addGiftVoucher', function()
	{
		var sInputValue = $(el('edtVoucher')).val();
		var sInputWebCodeValue = $(el('edtWebCode')).val();
		var bWebcodeAlwaysVisible = ($('.webcodeAlwaysVisible').length > 0);
		sInputValue = (bRemoveSpacesFromVoucherReferenceInput) ? sInputValue.trim().replaceAll(" ","") : sInputValue;
		sInputWebCodeValue = (bRemoveSpacesFromVoucherReferenceInput) ? sInputWebCodeValue.trim().replaceAll(" ","") : sInputWebCodeValue;
		if($('#edtWebCode').is(":visible") && !bWebcodeAlwaysVisible)
		{
			if(fieldIsValid($('#edtWebCode')))
			{
				submitGiftVoucher(sInputValue.toUpperCase(), $(el('edtWebCode')).val().toUpperCase());
			}
			else
			{
				setFieldValidationState($('#edtWebCode'),'error');
			}
		}
		else
		{
			if(bWebcodeAlwaysVisible) {
				if (sInputWebCodeValue == '' && sInputValue == '') {
					setFieldValidationState($('#edtVoucher'),'error');
				} else if ($('.webcodeAlwaysVisible').prop('required') && sInputWebCodeValue == '') {
					setFieldValidationState($('#edtVoucher'),'success');
					setFieldValidationState($('#edtWebCode'),'error');
				} else {
					submitGiftVoucher(sInputValue.toUpperCase(), $(el('edtWebCode')).val().toUpperCase());
				}
			} else {
				submitGiftVoucher(sInputValue.toUpperCase(), $(el('edtWebCode')).val().toUpperCase());
			}
		}

		return false;
	});

	// promo form listener
	oBasket.on('click', '#addPromoCode', function()
	{
		submitGiftVoucher($(el('edtPromoCode')).val().toUpperCase(),'');

		return false;
	});

	// remove giftvoucher listener
	oBasket.on('click', '.icon-remove', function()
	{
		var oIcon = $(this);

		// the removal re-renders the cart; until then the cross turns into a spinner and ignores clicks
		if(oIcon.hasClass('is-loading')) return false;
		setRemoveIconBusy(oIcon, true);

		if(oIcon.hasClass('promoCode')){
			removePromoCode(oIcon.data('promocodeId'), oIcon);
		}
		else
		{
			removeGiftVoucher(oIcon.data('paymentId'), oIcon);
		}
		return false;
	});

	preventNegativeValue();

	$('.input-quantity').keyup(function()
	{
		makePositiveValue($(this));
	});

	oBasket.on('click', '.campainLink', function() {
		var sCollectMethod = $(this).data('collectMethod');
		var sShopId        = $(this).data('shopId');
		var sSku           = $(this).data('skuId');
		addFeaturedProduct(sSku, 1, sShopId, sCollectMethod);
		return false;
	});

	// Add product to basket (home delivery)
	oBasket.on('click','.checkoutCampaignPopupAddSku', function(e)
	{
		e.preventDefault();

		var sCollectMethod = $(this).data('collectMethod');
		var sShopId        = $(this).data('shopId');
		var sSku           = $(this).data('skuId');
		addFeaturedProduct(sSku, 1, sShopId, sCollectMethod);
		return false;
	});

	oBasket.on('click','.checkoutCampaignPopupAddConfiguration', function(e)
	{
		e.preventDefault();

		var sCollectMethod = $(this).data('collectMethod');
		var sShopId        = $(this).data('shopId');
		var sSku           = $(this).data('skuId');
		var sWebname       = $(this).data('webname');

		if(sSku)
		{
			var oSelectedSku = {};
			oSelectedSku.description = sWebname;
			oSelectedSku.quantity    = 1;
			oSelectedSku.skuId       = sSku;

			var addons = getSelectedAddons();
			addons.push(oSelectedSku);

			sAddons = JSON.stringify(addons);
			addFeaturedConfiguration(oSelectedSku.skuId,oSelectedSku.quantity,sShopId,sCollectMethod,sAddons);
		}
		return false;
	});

	oBasket.on('click', '.qtyBtn', function(e) {
		e.preventDefault();

		var oEdtQty    = $(this).parents('.priceData').find('.edtQty');

		var iCurrentVal = parseInt(oEdtQty.val());
		var iMultiplier = parseInt(oEdtQty.data('qtyMultiplier'));
		var sType      = $(this).attr('data-type');

		if (!isNaN(iCurrentVal))
		{
			if(sType === 'minus')
			{
				if(iCurrentVal > oEdtQty.attr('min'))
				{
					oEdtQty.val(iCurrentVal - (1*iMultiplier)).change();
				}
			}
			else if(sType === 'plus')
			{
				oEdtQty.val(iCurrentVal + (1*iMultiplier)).change();
			}
		}
	});

	oBasket.on('click', '.btnToCheckout,.offsetFreeDelivery', function(e) {
		e.preventDefault();

		// Prevent checkout if button is disabled (e.g., cera validation required)
		if ($(this).hasClass('disabled')) {
			return false;
		}

		var sHref = this.href;

		// A quantity set in the last few hundred ms is still sitting on the debounce, so send it before
		// leaving - otherwise the basket the customer checks out with is not the one on screen.
		flushLineQty(function()
		{
			if($(el('offsetForFreeDeliveryModal')).length)
			{
				promptOffsetForFreeDeliveryModal()
			}
			else
			{
				window.location = sHref;
			}
		});
	});

	oBasket.on('hide', '#offsetForFreeDeliveryModal', function()
	{
		window.location = $('.btnToCheckout').attr('href');
	});

	if($(window).width() < 768)
	{
		$(el('offsetForFreeDeliveryModal')).one('shown', function()
		{
			$('.featuredproducts .flexslider').each(function(index){
				$(this).flexslider({
					animation: "slide",
					animationLoop: false,
					controlNav: false,
					itemMargin: 0,
					slideshow: false,
					touch: true
				});
			});
			centerPopups();
		});
	}

	oBasket.on('change keyup', '#edtVoucher', function(e)
	{
		var sInput = $(el('edtVoucher')).val().toLowerCase().replace(/\s/g,'');
		if(sInput.length > 1)
		{
			// Check if code starts with voucher prething
			var aListVoucher = ["gft","loy","cv","vrn","0000"];
			matched = false;
			for(i=0; i<= aListVoucher.length; i++)
			{
				if((sTenantId === 175 && (sInput === "0000000000215" || sInput === "0000000000284")) || (sTenantId === 154 && (sInput === "0000000001083" || sInput === "0000000001120")))
				{
					$(el('edtWebCode')).closest('.control-group').hide();
				}
				else if(sInput.indexOf(aListVoucher[i]) == 0)
				{
					$(el('edtWebCode')).closest('.control-group').show();
					$('.webcodeAlwaysVisible').prop('required', true);
					matched = true;
					break;
				} else {
					$('.webcodeAlwaysVisible').prop('required', false);
				}
			}
			if(!matched)
			{
				// Check years
				if(sInput.length > 3)
				{
					var checkYear = parseInt(sInput.substring(0,4));
					if(!isNaN(parseFloat(checkYear)) && isFinite(checkYear))
					{
						if(checkYear > 2000 && checkYear < 3000)
						{
							// it is a year
							$(el('edtWebCode')).closest('.control-group').show();
						}
					}
					else
					{
						$(el('edtWebCode')).closest('.control-group').hide();
					}
				}
				else
				{
					$(el('edtWebCode')).closest('.control-group').hide();
				}
			}
		}
		else
		{
			$(el('edtWebCode')).closest('.control-group').hide();
		}
	});

	oBasket.on("click", ".entryPreview", function(e)
	{
		var oEntryPreviewBtn = $(this);
		if(oEntryPreviewBtn.hasClass('loaded'))
		{
			oEntryPreviewBtn.parents(".entryPreviewWrapper").find(".entryPreviewImages a").first().trigger("click");
		}
		else
		{
			oEntryPreviewBtn.addClass("loading");
			sEntryId = oEntryPreviewBtn.data('entryId');

			oCall = entryPreview(sEntryId);
			oCall.success(function(oData)
			{
				oEntryPreviewBtn.removeClass("loading");

				if(oData.errorMessage == "" && typeof oData.entry !== "undefined" && typeof oData.entry.result !== "undefined" && oData.entry.result.length > 0)
				{
					oEntryPreviewBtn.addClass('loaded');
					$.each(oData.entry.result, function( index, value ) {
						oEntryPreviewBtn.parents(".entryPreviewWrapper").find(".entryPreviewImages").append('<a href="' + value + '" data-fancybox="' + sEntryId + '"></a>');
					});
					oEntryPreviewBtn.parents(".entryPreviewWrapper").find(".entryPreviewImages a").first().trigger("click");
				}
				else
				{
					showAlert('error', oData.errorMessage, oData.errorUnhandled);
				}
			});
		}
	});

	// Validate Cera numbers button click
	oBasket.on('click','#btnValidateCera', function(e)
	{
		e.preventDefault();
		saveCeraNumbers($(el("ceraForm")));
	});

	// Clear validation icons when user types
	oBasket.on('input','.edtCeraNumber', function(e)
	{
		$('.ceraValidIcon').remove();
		// Disable transaction submit until validated
		disableTransactionSubmit();
	});

	oBasket.on('click','#askClearBasket', function(e)
	{
		askClearBasket();
	});

	oBasket.on('click','#clearBasket', function(e)
	{
		clearBasket();
	});

	// Wishlist on a basket line. Same two mechanisms as the PDP (product/detail.js): the new wishlist
	// (themeConfig.enableNewWishlist) works on a sku through the wishlist module, the legacy favourites
	// list works on a product id. Unlike a product thumb, a basket line already knows both - it is one
	// concrete sku - so nothing has to be resolved from a size selector first.
	oBasket.on('click', '.btnAddToWishlistBasket', function(e)
	{
		e.preventDefault();

		var oBtn = $(this);
		oBtn.prop('disabled', true);

		if(typeof bEnableNewWishlist !== "undefined" && bEnableNewWishlist)
		{
			// resolves the sku off the button's data-skuid; the wishlistSkuChanged event flips the button
			addToWishlistPopup(oBtn, oBtn.data('productId'));
		}
		else
		{
			addToWishlist(oBtn.data('productId'));
			setBasketWishlistState(oBtn, true);
			oBtn.prop('disabled', false);
		}
	});

	oBasket.on('click', '.btnRemoveFromWishlistBasket', function(e)
	{
		e.preventDefault();

		var oBtn = $(this);
		oBtn.prop('disabled', true);

		if(typeof bEnableNewWishlist !== "undefined" && bEnableNewWishlist)
		{
			deleteFromWishlist(oBtn);
		}
		else
		{
			removeFromwishlist(oBtn.data('productId'));
			setBasketWishlistState(oBtn, false);
			oBtn.prop('disabled', false);
		}
	});

	// The add/remove round trips live in global.js and only know how to repaint a product thumb, so the
	// basket buttons listen for the outcome instead. Bound on document, once: the basket markup itself is
	// replaced wholesale on every quantity change.
	$(document).on('wishlistSkuChanged', function(e, sSkuId, bInWishlist)
	{
		setBasketWishlistState($('.btnWishlistBasket[data-skuid="' + sSkuId + '"]'), bInWishlist);
	});

	init();
	if(bEnableCalcDeliveryPromise) calcDeliveryPromise();
});

function askClearBasket()
{
	var oPopup = $('#popupContinue');
	setAction(oPopup, 'clearBasket', {});
	setPopupHeader(oPopup, sAskClearBasketTitle, '');
	oPopup.find('.modal-body .content').html(sAskClearBasketContent);

	oPopup.find('.modal-footer .action').addClass("btn-alternate").html(sAskClearBasketConfirm);
	oPopup.find('.modal-footer .cancel').addClass("btn-primary").html(sCancel);

	oPopup.modal();
}

function clearBasket()
{
	var oCall = callAjax("clearBasket", "", "post","/index.cfm/transaction/ajax/clearBasket");
	// process feedback
	oCall.success(function(oData)
	{
		if(oData.errorType == '')
		{
			$(el('popupContinue')).modal('hide');
			$(el('mainContent')).html(oData.html);
			$(el('edtWebCode')).closest('.control-group').hide();
			checkCeraValidationState();

			getBasketDropdownHeader();

			init();
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function saveCeraNumbers(oFrm)
{
	// Disable button during validation
	$('#btnValidateCera').prop('disabled', true).text('Validating...');
	
	var sParams = getValues(oFrm);
	var oCall = callAjax("saveCeraNumbers", sParams, "post","/index.cfm/transaction/ajax/saveCeraNumbers");
	// process feedback
	oCall.success(function(oData)
	{
		// Re-enable button
		$('#btnValidateCera').prop('disabled', false).text($('#btnValidateCera').data('original-text') || 'Validate');
		
		if(oData.errorType == '')
		{
			// Remove any existing icons first to avoid duplicates
			$('.ceraValidIcon').remove();
			
			// Validation successful - show check icons and enable submit
			$('.edtCeraNumber').each(function() {
				if($(this).val() !== '') {
					$(this).parent().append('<i class="far fa-check-circle ceraValidIcon"></i>');
				}
			});
			enableTransactionSubmit();
		}
		else
		{
			// show error message and keep submit disabled
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
			disableTransactionSubmit();
		}
	});
}

function enableTransactionSubmit()
{
	// Only control submit button if cera form exists
	if ($('#ceraForm').length > 0) {
		$('.transaction .btnToCta, .transaction .btnToCheckout').removeClass('disabled').css('pointer-events', 'auto').prop('disabled', false);
		
		// Also enable buttons inside links to checkout
		$('a[href*="/transaction/checkout"]').removeClass('disabled').css('pointer-events', 'auto');
		$('a[href*="/transaction/checkout"] button').prop('disabled', false);
	}
}

function disableTransactionSubmit()
{
	// Only control submit button if cera form exists
	if ($('#ceraForm').length > 0) {
		$('.transaction .btnToCta, .transaction .btnToCheckout').addClass('disabled').css('pointer-events', 'none').prop('disabled', true);
		
		// Also disable buttons inside links to checkout
		$('a[href*="/transaction/checkout"]').addClass('disabled').css('pointer-events', 'none');
		$('a[href*="/transaction/checkout"] button').prop('disabled', true);
	}
}

function addFeaturedConfiguration(sSku, iQty, sShopId, sCollectMethod,sAddons)
{
	// Set loader
	var sParams = '&mainSkuId=' + sSku
				+ '&mainSkuQty=' + iQty
				+ '&shopId=' + sShopId
				+ '&collectMethodId=' + sCollectMethod
				+ '&addons=' + encodeURIComponent(sAddons);
	var oCall = callAjax("addConfiguration", sParams, "post", uAjaxBasket);
	// process feedback
	oCall.success(function(oData)
	{
		$('.checkoutCampaignPopup').modal('hide');

		if(oData.errorType == '')
		{
			// Add to basket successful
			$('#mainContent').html(oData.html);
			$(el('edtWebCode')).closest('.control-group').hide();

			init();
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function addFeaturedProduct(sSku, iQty, sShopId, sCollectMethod)
{
	// Set loader
	var sParams = '&skuId=' + sSku
				+ '&qty=' + iQty
				+ '&idShop=' + sShopId
				+ '&collectMethodId=' + sCollectMethod
				+ '&customHtml=index';
	var oCall = callAjax("addSku", sParams, "post", uAjaxBasket);
	// process feedback
	oCall.success(function(oData)
	{
		$('.checkoutCampaignPopup').modal('hide');

		if(oData.errorType == '')
		{
			// Add to basket successful
			$('#mainContent').html(oData.html);
			$(el('edtWebCode')).closest('.control-group').hide();
			checkCeraValidationState();

			init();
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function askRemoveLine(sLineId)
{
	var oPopup = $('#popupContinue');

	setAction(oPopup, 'removeLine', {'line-id': sLineId});
	setPopupHeader(oPopup, sAskRemoveLineTitle, '');
	oPopup.find('.modal-body .content').html(sAskRemoveLineContent);

	oPopup.find('.modal-footer .action').html(sAskRemoveLineConfirm);
	oPopup.find('.modal-footer .cancel').html(sAskRemoveLineCancel);

	oPopup.modal();
}

function calcDeliveryPromise()
{
	clearErrors();

	// AJAX call
	var oCall   = callAjax("calcDeliveryPromise", "", "post", uAjaxBasket);
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			$(el('mainContent')).html(oData.html);

			$(el('edtWebCode')).closest('.control-group').hide();
			checkCeraValidationState();

			// refresh basket dropdown
			getBasketDropdownHeader();

			init();
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function changeLineQty(sLineId, iQty, fnDone)
{
	clearErrors();

	var buttons = $('[line-id=' + sLineId + ']').parent().find('.qtyBtn');
	buttons.each(function(){
		$(this).prop('disabled', true);
	});

	// the totals only change when the whole cart comes back; mark them stale in the meantime so the
	// wait reads as "updating" instead of "nothing happened" (the class leaves with the old markup)
	setBasketUpdating(true);

	// AJAX call
	var sParams = '&lineId=' + sLineId + '&lineQty=' + iQty;
	var oCall   = callAjax("changeLineQty", sParams, "post", uAjaxBasket);
	oCall.fail(function()
	{
		setBasketUpdating(false);
	});
	oCall.success(function(oData)
	{
		if(oData.errorType === '' || oData.errorType === 'qtyChangedByStock')
		{
			$(el('mainContent')).html(oData.html);
			$(el('edtWebCode')).closest('.control-group').hide();
			checkCeraValidationState();

			// Only a limit the customer actually ran into is worth a warning. A plain quantity change
			// needs none: the line and the totals already show the new number, and warning on every
			// single change turned the stepper into a stream of alerts.
			if (oData.errorType === 'qtyChangedByStock')
			{
				showAlert('warning', tStockErrorSku || oData.errorMessage, false, 8000);
			}
			else if (oData.quantityError)
			{
				var oProductLine = $('[line-id=' + sLineId + ']').parents('.productLine');

				// floating fallback for a context that has no line to anchor to (the basket dropdown)
				if (oProductLine.length > 0)
				{
					oProductLine.parent().css('position', 'relative');
					inlineAlert('warning productLineWarning', tMinQuantityChanged, false, oProductLine,false,null,true,null);
				}
				else
				{
					showAlert('warning', tMinQuantityChanged, false, '1000');
				}
			}

			// refresh basket dropdown
			getBasketDropdownHeader();

			init();

			if(typeof voyadoEnabled !== "undefined" && voyadoEnabled)
			{
				$(document).trigger(oData.functionVoyado,[oData.cartVoyado]);
			}
		}
		else if(oData.errorType === 'EMaximumOrderQuantityReached')
		{
			var iMaxOrderQuantity = $('[line-id=' + sLineId + ']').data("max-order-quantity");
			if(typeof iMaxOrderQuantity != "undefined") $('[line-id=' + sLineId + ']').val(iMaxOrderQuantity);

			if($('[line-id=' + sLineId + ']').parents('.line-wrapper').length > 0)
			{
				inlineAlert('error', oData.errorMessage, false, $('[line-id=' + sLineId + ']').parents('.line-wrapper'),false);
			}
			else
			{
				showAlert('error', oData.errorMessage, false, '1000');
			}
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
		$('.ajaxLoader').fadeOut(200);
		setBasketUpdating(false);

		buttons.each(function(){
			$(this).prop('disabled', false);
		});

		// only on a clean change: anything else has just put an alert on screen, and a caller waiting
		// on this (the checkout button) must not navigate away from it
		if(typeof fnDone === "function" && oData.errorType === '') fnDone();
	});
}

// Stale-totals marker while a quantity change is on its way. Structural class only; the app stylesheet
// dims the receipt and line prices, a theme may do more. No-op when the cart has no .line-wrapper.
function setBasketUpdating(bBusy)
{
	$(el('mainContent')).find('.line-wrapper').toggleClass('is-updating', bBusy);
}

// Shared success path of the voucher and promo-code mutations on the cart page: the server hands back
// the whole cart (view=cart), which is swapped in place exactly like a line removal. No page reload, so
// the spinner on the clicked control leaves together with the old markup.
function swapCartContent(sHtml)
{
	$(el('mainContent')).html(sHtml);
	$(el('edtWebCode')).closest('.control-group').hide();
	checkCeraValidationState();
	getBasketDropdownHeader();

	init();
}

// Every stepper click used to fire its own round trip, and each one re-renders the whole basket - so
// holding "+" queued a request per click and the warning only showed up once the last one came back.
// A burst on the same line collapses into a single call carrying the final quantity. The number in the
// field is already updated by the click handler, so the wait only defers the totals, never the stepper.
var iLineQtyDebounce = 400;
var oLineQtyPending  = {};

function queueLineQty(oEdtQty, bImmediate)
{
	var sLineId = oEdtQty.attr('line-id');

	if(typeof sLineId === "undefined") return;

	// reads the value at fire time, not at queue time, so the last click of a burst is the one that counts
	var fnApply = function(fnDone)
	{
		delete oLineQtyPending[sLineId];

		if(oEdtQty.val() == 0) removeLine(sLineId, fnDone);
		else validateQty(oEdtQty.val(), sLineId, fnDone);
	};

	if(oLineQtyPending.hasOwnProperty(sLineId)) clearTimeout(oLineQtyPending[sLineId].timer);

	if(bImmediate)
	{
		fnApply();
		return;
	}

	// wrapped: setTimeout must not hand fnApply an argument, fnDone is only for an explicit flush
	oLineQtyPending[sLineId] = { timer: setTimeout(function(){ fnApply(); }, iLineQtyDebounce), apply: fnApply };
}

// Sends anything still waiting on the debounce and calls fnDone once it has landed. Nothing pending
// means fnDone runs straight away, so a caller can use this unconditionally.
function flushLineQty(fnDone)
{
	var aPending = [];

	for(var sLineId in oLineQtyPending)
	{
		if(oLineQtyPending.hasOwnProperty(sLineId)) aPending.push(oLineQtyPending[sLineId]);
	}

	if(aPending.length === 0)
	{
		fnDone();
		return;
	}

	// fnDone hangs off the last one: they all re-render the basket, and only the final response matters
	var iRemaining = aPending.length;
	$.each(aPending, function(i, oEntry)
	{
		clearTimeout(oEntry.timer);
		oEntry.apply(function()
		{
			iRemaining--;
			if(iRemaining === 0) fnDone();
		});
	});
}

function changeQty(edtQty, type)
{
	if (type == 'plus') {
		if (edtQty.prop('value') < 9999) {
			edtQty.prop('value', parseInt(edtQty.prop('value')) + 1);
		}
	} else {
		if (edtQty.prop('value') > 1) {
			edtQty.prop('value', parseInt(edtQty.prop('value')) - 1);
		}
	}

	$(edtQty).trigger('change');
}

function disableQtyEdit()
{
	var arraySerialRequiredLines = JSON.parse(aSerialRequiredLines)
	$(arraySerialRequiredLines).each(function(i,el)
	{
		var oInput = $('.edtQty[line-id*=' + el + ']');
		oInput.prop('disabled', true);
		oInput.parents('.input-prepend.input-append').find('.qtyBtn').prop('disabled', true);
	});
}

function entryPreview(sEntryId)
{
	var sParams = '&entryId=' + sEntryId;

	return callAjax("entrypreview", sParams, "post", "/index.cfm/product/ajax/entrypreview");
}

function init()
{
	disableQtyEdit();
	initLazyResponsiveLoad();
	if (typeof initFlexSliders === "function") initFlexSliders();
	if (typeof initFeaturedProducts === "function") initFeaturedProducts();
	if (typeof initFeaturedProductsGridSlider === "function") initFeaturedProductsGridSlider();
	if (typeof initForms === "function") initForms();
	if (typeof initContentEventHandlers === "function") initContentEventHandlers();
	if (typeof initHotSpotImages === "function") initHotSpotImages();
	if (typeof initPaymentOptions === "function") initPaymentOptions();
	syncBasketWishlistButtons();
	ciResponsive.process();
}

function preventNegativeValue()
{
	var quantityField = $(".input-quantity");

	quantityField.keypress(function(event)
	{
		if ( event.which == 45 ) {
			event.preventDefault();
		}
	});

}
function makePositiveValue(element)
{
	var quantityFieldValue = element.val();
	var positiveValue = Math.abs(quantityFieldValue);
	element.val(positiveValue);
}

function promptOffsetForFreeDeliveryModal()
{
	$(el('offsetForFreeDeliveryModal')).modal('show');
}

// Busy state for the remove crosses next to a promo code or gift voucher (basket_totals markup in the
// themes: <i class="icon-remove fa fa-times ...">). Swaps the cross for a spinner and back.
function setRemoveIconBusy(oIcon, bBusy)
{
	if(!oIcon || oIcon.length === 0) return;

	oIcon.toggleClass('is-loading', bBusy)
	     .toggleClass('fa-times', !bBusy)
	     .toggleClass('fa-spinner fa-spin', bBusy);
}

function removeGiftVoucher(sPaymentId, oIcon)
{
	var sParams = '&paymentId=' + sPaymentId + '&view=cart';
	var oCall   = callAjax("removePayment", sParams, "post", uAjaxBasket);
	oCall.fail(function()
	{
		setRemoveIconBusy(oIcon, false);
	});
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			swapCartContent(oData.html);
		}
		else
		{
			setRemoveIconBusy(oIcon, false);
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function removeLine(lineId, fnDone) {
	var sParams = '&lineId=' + lineId;
	var oCall = callAjax("deleteLine", sParams, "post", uAjaxBasket);
	oCall.success(function(oData) {
		if (oData.errorType == '')
		{
			$('#popupContinue').modal('hide');
			showAlert('info', tLineRemoved, false, 4000);
			$('#mainContent').html(oData.html);
			$(el('edtWebCode')).closest('.control-group').hide();
			checkCeraValidationState();
			getBasketDropdownHeader();

			init();

			$(document).trigger( "removeLine",[lineId]);

			if(typeof voyadoEnabled !== "undefined" && voyadoEnabled)
			{
				$(document).trigger(oData.functionVoyado,[oData.cartVoyado]);
			}
		} else {
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
		$('.ajaxLoader').fadeOut(200);

		// see changeLineQty: a waiting caller only proceeds on a clean removal
		if(typeof fnDone === "function" && oData.errorType == '') fnDone();
	});
}

function removePromoCode(sPromoCodeId, oIcon)
{
	var sParams = '&promoCodeId=' + sPromoCodeId + '&view=cart';
	var oCall   = callAjax("removePromoCode", sParams, "post", uAjaxBasket);
	oCall.fail(function()
	{
		setRemoveIconBusy(oIcon, false);
	});
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			swapCartContent(oData.html);
		}
		else
		{
			setRemoveIconBusy(oIcon, false);
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

// Paints a basket-line wishlist button as "in the wishlist" or not. The class the click handlers key on
// is the contract - a theme styles the two states off it. The icon swap is the same solid/regular pair
// the wishlist header links use, and is skipped for a theme that renders something else.
// data-title-add / data-title-remove are optional.
function setBasketWishlistState(oBtns, bInWishlist)
{
	oBtns.each(function()
	{
		var oBtn   = $(this);
		var sTitle = oBtn.data(bInWishlist ? 'titleRemove' : 'titleAdd');

		oBtn.toggleClass('btnRemoveFromWishlistBasket', bInWishlist).toggleClass('btnAddToWishlistBasket', !bInWishlist);
		oBtn.find('i.fa-heart').toggleClass('fas', bInWishlist).toggleClass('far', !bInWishlist);

		if(typeof sTitle !== "undefined") oBtn.attr('title', sTitle);

		oBtn.prop('disabled', false);
	});
}

// Seeds the buttons after every render of the basket (the whole markup is replaced on a quantity
// change). Only the new wishlist keeps a client-side list of skus; with the legacy favourites list the
// server-rendered class is the only source, so it is left alone.
function syncBasketWishlistButtons()
{
	var oBtns = $('.btnWishlistBasket');

	if(oBtns.length === 0 || typeof bEnableNewWishlist === "undefined" || !bEnableNewWishlist) return;

	var aWishlistSkus = String(typeof sWishlistProducts !== "undefined" ? sWishlistProducts : "").split(",");

	oBtns.each(function()
	{
		var oBtn = $(this);
		setBasketWishlistState(oBtn, aWishlistSkus.indexOf(String(oBtn.data('skuid'))) !== -1);
	});
}

// Busy state on the add-code controls of the cart page (the checkout page has its own copy in
// addgiftvoucher.js, which is not loaded here). Disabled + is-loading, the stylesheet paints the spinner.
function setCartGiftVoucherBusy(bBusy)
{
	$(el('addGiftVoucher')).prop('disabled', bBusy).toggleClass('is-loading', bBusy);
	$(el('addPromoCode')).prop('disabled', bBusy).toggleClass('is-loading', bBusy);
}

function submitGiftVoucher(sGiftVoucher, sWebCode)
{
	// single-flight: a second click while the first is still on its way would add the code twice
	if($(el('addGiftVoucher')).hasClass('is-loading') || $(el('addPromoCode')).hasClass('is-loading')) return;

	if($.trim(sWebCode) === '')
	{
		sWebCode = '000';
	}
	var sParams = '&giftvoucher=' + encodeURIComponent(sGiftVoucher) + '&webcode=' + sWebCode + '&view=cart';

	setCartGiftVoucherBusy(true);

	var oCall   = callAjax("addGiftVoucher", sParams, "post", uAjaxBasket);
	oCall.fail(function()
	{
		setCartGiftVoucherBusy(false);
	});
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			// the controls are part of the markup being replaced, so no reset is needed here
			swapCartContent(oData.html);
		}
		else
		{
			setCartGiftVoucherBusy(false);

			if(oData.errorType === 'EVoucherInvalidWebcode')
			{
				showAlert('error', tInvalidWebcode, oData.errorUnhandled,3000);
			}
			else if(oData.errorType === 'EVoucherCannotBeValidatedWithoutWebCode')
			{
				showAlert('error', tEmptyWebcode, oData.errorUnhandled,3000);
			}
			else {
				showAlert('error', oData.errorMessage, oData.errorUnhandled,3000);
			}
		}
	});
}

function validateQty(iQty, sLineId, fnDone)
{
	if(isNaN(iQty) !== true && iQty != ""){
		iQty = Math.abs(iQty);
		changeLineQty(sLineId, iQty, fnDone);
	}
	else if(typeof fnDone === "function")
	{
		fnDone();
	}
}

function checkMultiplier(qtyInput)
{
	var qty = parseInt(qtyInput.val());
	var multiplier = parseInt(qtyInput.data('qtyMultiplier'));

	if(typeof qtyInput.data('min') !== 'undefined')
	{
		var minQty = parseInt(qtyInput.data('min'));
		if(qty < minQty)
		{
			qty = minQty;
			qtyInput.val(qty);
		}
	}
	if(multiplier > 1)
	{
		if(qty < multiplier)
		{
			qtyInput.val(multiplier);
		}
		else
		{
			var diffQty = (qty % multiplier);
			if(diffQty !== 0)
			{
				var newQty = Math.ceil(qty/multiplier) * multiplier;
				qtyInput.val(newQty);
			}
		}
	}
}


// Additional Info / Samples Modal functionality
$(function() {
	var oBasket = $(el('mainContainer'));
	
	// Open additional info modal
	oBasket.on('click', '.editAdditionalInfo', function() {
		if (typeof centerPopups === 'function') {
			centerPopups();
		}
	});

	// Save additional info
	oBasket.on('click', '#saveAdditionalInfo', function(e) {
		e.stopPropagation();
		var sAdditionalInfo = (typeof $('.inputAdditionalInfo').val() != "undefined") ? $('.inputAdditionalInfo').val() : "";
		var sExternalReference = (typeof $('.inputExternalReference').val() != "undefined") ? $('.inputExternalReference').val() : "";

		updateAdditionalInfo(sAdditionalInfo, sExternalReference);
		return false;
	});

	// Remove additional info
	oBasket.on('click', '.btnRemoveAdditionalInfo', function(e) {
		e.preventDefault();
		// Clear both fields by saving empty values
		updateAdditionalInfo('', '');
		return false;
	});
});

function updateAdditionalInfo(sAdditionalInfo, sExternalReference) {
	var sUrl = uAjaxBasket + "/changeadditionalinfo";  // was assigning the shared global
	var sParams = "&transactionId=" + transactionId + "&additionalInfo=" + encodeURIComponent(sAdditionalInfo) + "&externalReference=" + encodeURIComponent(sExternalReference);
	var oCall = callAjax('changeadditionalinfo', sParams, 'POST', sUrl);
	oCall.success(function(oData) {
		if(oData.ErrorType === '') {
			$(el('additionalInfo')).modal('hide');
			// Ensure backdrop is removed
			$('.modal-backdrop').remove();
			$('body').removeClass('modal-open');
			
			// Update cart page display if container exists
			if($('#additionalInfoDisplayContainer').length > 0) {
				updateCartAdditionalInfoDisplay(sAdditionalInfo, sExternalReference);
			}
		} else {
			if (typeof showAlert === 'function') {
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}
		}
	});
}

function updateCartAdditionalInfoDisplay(sAdditionalInfo, sExternalReference) {
	var hasInfo = (sAdditionalInfo && sAdditionalInfo.trim() !== '') || (sExternalReference && sExternalReference.trim() !== '');
	var container = $('#additionalInfoDisplayContainer');
	
	if (hasInfo) {
		var infoText = '';
		if (sAdditionalInfo && sAdditionalInfo.trim() !== '') {
			infoText += sAdditionalInfo;
		}
		if (sExternalReference && sExternalReference.trim() !== '') {
			if (infoText !== '') {
				infoText += ' - ';
			}
			infoText += sExternalReference;
		}
		
		var html = '<div class="row additionalInfoRow">' +
			'<div class="span12">' +
			'<div class="additionalInfoDisplay">' +
			'<button class="btn btn-small btn-danger btnRemoveAdditionalInfo" data-title="Remove" data-placement="top">' +
			'<i class="fa fa-trash"></i>' +
			'</button>' +
			'<span class="additionalInfoText">' +
			'<strong>' + (typeof tSamples !== 'undefined' ? tSamples.toUpperCase() : 'SAMPLES') + ':</strong> ' +
			'<span class="transactionAdditionalInfo">' + infoText + '</span>' +
			'</span>' +
			'</div>' +
			'</div>' +
			'</div>';
		
		container.html(html);
	} else {
		container.html('');
	}
}
